import _ from 'lodash';
import moment from 'moment';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import GasBuddyPricesContainer from '../containers/reports/GasBuddyPrices';
import FMPStationSelect from './pureForm/FMPStationSelect';
import StationsContainer from '../containers/Stations';
import FMPText from './pureForm/FMPText';
import Button from '@material-ui/core/Button';
import FMPSelect from './pureForm/FMPSelect';

class AddRetailPrice extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			stationId: '',
			formFieldError: {},
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { stationId, stations, searchStations } = this.props;

		if (_.isEmpty(stations)) {
			searchStations();
		}

		if (stationId) {
			this.setState({ stationId });
		}
	}

	handleAddPrice = () => {
		const { showErrors, addGasBuddyPrice, afterSave } = this.props;
		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		let fields = [
			{ path: 'stationId', display: 'Station' },
			{ path: 'gasBuddyPrice', display: 'Retail Price' },
		];
		fields.forEach((s) => {
			if (!_.get(this.state, s.path)) {
				_setError(s.path, `${s.display} is required`);
			}
		});

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		const { stationId, gasBuddyPrice, daysToLockPrice } = this.state;

		const params = {
			stationId,
			gasBuddyPrice: parseFloat(gasBuddyPrice),
		};

		if (daysToLockPrice && parseInt(daysToLockPrice)) {
			const d = parseInt(daysToLockPrice);
			params.lockedUntilDateTime = moment().add(d, 'days').utc().format('YYYY-MM-DD HH:mm:ss');
		}

		addGasBuddyPrice({
			params,
			callback: () => {
				if (_.isFunction(afterSave)) {
					afterSave();
				}
			},
		});
	};

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getInputProps = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.onChange,
			md: 6,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { stationId, stations, doNotShowStation } = this.props;

		const readOnly = !!stationId;

		const publicStations = [];
		stations.forEach((station) => {
			if (station.stationIsNotPublic) {
				return;
			}
			publicStations.push(station);
		});

		const optionsForDaysToLockPrice = [];
		const dayList = _.range(0, 10);
		dayList.push(10, 15, 20, 30, 31, 60, 90, 120);

		dayList.forEach((x) => {
			if (x === 0) {
				optionsForDaysToLockPrice.push({ value: x, display: `No Lock` });
			} else {
				optionsForDaysToLockPrice.push({ value: x, display: `Lock for ${x} days` });
			}
		});

		return (
			<Grid spacing={2} container style={{ alignItems: 'center' }}>
				{!doNotShowStation && (
					<FMPStationSelect
						{...this.getInputProps('stationId')}
						label="Station"
						stations={publicStations}
						readOnly={readOnly}
						contained={false}
						md={4}
						helpText={readOnly ? 'Locked in' : 'Only public stations'}
					/>
				)}

				<FMPText
					label="Retail Price"
					{...this.getInputProps('gasBuddyPrice')}
					contained={false}
					md={doNotShowStation ? 4 : 2}
					helpText={'Include as many decimals as needed'}
				/>

				<FMPSelect
					label="Days To Lock Price"
					{...this.getInputProps('daysToLockPrice')}
					contained={false}
					md={doNotShowStation ? 5 : 3}
					helpText={'Locked prices can not be overridden by GasBuddy'}
					options={optionsForDaysToLockPrice}
				/>

				<Grid item xs={12} md={doNotShowStation ? 3 : 2}>
					<Button
						variant="contained"
						color="primary"
						style={{ borderRadius: '30px' }}
						onClick={this.handleAddPrice}
					>
						Add Retail Price
					</Button>
				</Grid>
			</Grid>
		);
	}
}

AddRetailPrice.propTypes = {
	stations: PropTypes.array,
	doNotShowStation: PropTypes.bool,
	searchStations: PropTypes.func.isRequired,
	addGasBuddyPrice: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,
	stationId: PropTypes.number,
	afterSave: PropTypes.func.isRequired,
};

AddRetailPrice.defaultProps = {};

export default _.flow([GasBuddyPricesContainer, StationsContainer])(AddRetailPrice);
